import { render, staticRenderFns } from "./recover_password.vue?vue&type=template&id=1a45e2ab&scoped=true&"
import script from "./recover_password.vue?vue&type=script&lang=js&"
export * from "./recover_password.vue?vue&type=script&lang=js&"
import style0 from "./recover_password.vue?vue&type=style&index=0&id=1a45e2ab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a45e2ab",
  null
  
)

export default component.exports